import { createSlice } from "@reduxjs/toolkit";
import { fetchUserDetails } from "./authThunk";
import { filteredAccessPermissions } from "src/utils/routeHelper";
const savedToken = localStorage.getItem("token");
const initialState = {
  accessPermissions: [],
  token: savedToken || null,
  authStatus: 'idle',
  userRole: {},
  authError: null,
}
export const authPersistenceMiddleware = store => next => action => {
  const result = next(action);
  const { token } = store.getState().auth;

  if (!token) localStorage.removeItem("token");
  if (token) localStorage.setItem("token", token);
  return result;
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action) {
      state.token = action.payload;
    },
    setAccessPermission(state, action) {
      state.accessPermissions = action.payload;
    },
    clearAuth(state) {
      state.token = null;
      state.accessPermissions = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.pending, (state) => {
        state.authStatus = 'loading';
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        const accessPermission = action.payload.accessPermissions;

        const filteredAccess = filteredAccessPermissions(accessPermission);
        const role = action.payload.role;

        state.userRole = {
          approver: Boolean(role?.approver),
          description: role?.description,
          role: role?.role,
        };
        state.accessPermissions = filteredAccess;
        state.authStatus = 'succeeded';
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.authStatus = 'failed'
        state.error = action.payload || 'Failed to fetch user details';
      })

  }
})

export const { setToken, setAccessPermission, clearAuth } = authSlice.actions
export default authSlice.reducer
